class ErrorRequestFailed extends Error {
  constructor (errors, message, ...args) {
    super(message, ...args)
    this.errors = errors
    this.message = message
    Error.captureStackTrace(this, ErrorRequestFailed)
  }
}

export default ErrorRequestFailed



// WEBPACK FOOTER //
// ./src/models/ErrorRequestFailed.js